function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import styled, { css } from "styled-components";
import { media, themeGet } from "sprout-ui-theme";
import { Box } from "sprout-ui-primitives";
import { MoveItemsDialogView } from "./MoveItemsDialogContext";
const StyledBox = styled(Box)`
  padding: 0 8px 16px;

  ${media.up("small")} {
    padding: 0 0 16px;
  }
`;
const Input = styled("input")`
  height: 40px;
  padding: 0 8px;

  appearance: none;
  border: 0;
  outline: 0;

  width: 100%;

  ${({ isError  })=>css`
      ::placeholder {
        color: ${isError ? "#ff1744" : themeGet("colors.black.60")};
      }
    `};

  border-radius: 30px;
`;
const MoveItemsDialogInput = (props)=>{
    const { getInputProps , error , view , onRequestClose  } = props;
    const handleKeyDown = useCallback((event)=>{
        if (event.key === "Escape" && event.currentTarget.value.length === 0) onRequestClose(new Error("Closing `MoveItemsDialog"));
    }, [
        onRequestClose
    ]);
    return /*#__PURE__*/ _jsx(StyledBox, {
        borderBottomStyle: "solid",
        borderBottomColor: "white.12",
        borderBottomWidth: "1px",
        children: /*#__PURE__*/ _jsx(Input, _objectSpread({
            autoFocus: true,
            placeholder: error ? "Branch name is required" : view === MoveItemsDialogView.ADD ? "Branch name" : "Search"
        }, getInputProps({
            // https://github.com/microsoft/TypeScript/issues/38589#issuecomment-640769525
            isError: error,
            onKeyDown: handleKeyDown
        }), {
            // needed for `Downshift` quirks
            ref: undefined,
            as: undefined
        }))
    });
};
export default MoveItemsDialogInput;
